import SearchFormBasic from "./SearchFormBasic";
import COE from "./coe/COE";
import COESubscribeBox from "./coe/COESubscribeBox";
import InmateList from "./inmate_list/InmateList";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import COEUnregisterBox from "./coe/COEUnregisterBox";
import COERequestListBox from "./coe/COERequestListBox";
import COETransferEmailBox from "./coe/COETransferEmailBox";
import { PlusCircleIcon, MinusCircleIcon } from "@heroicons/react/solid";
import { Link } from "react-router-dom";

function TabBasic() {
  const subscribeBox = useSelector((state) => state.coe.subscribeBox);
  const [showHelp, setShowHelp] = useState(false);
  const [showCOE, setShowCOE] = useState(false);
  const Wrapper = window.innerWidth < 640 ? "div" : React.Fragment;

  return (
    <div className="">
      <div className=" md:flex block">
        <SearchFormBasic />

        <div
          className=" hover:bg-gray-200 m-auto rounded-md sm:hidden"
          onClick={() => setShowHelp(!showHelp)}
        >
          {!showHelp ? (
            <PlusCircleIcon className="h-5 float-left mt-1 mt-1" />
          ) : (
            <MinusCircleIcon className="h-5 float-left mt-1 mt-1" />
          )}
          <div className="ml-6 pt-px ">Help</div>
          <div className="h-px bg-black mt-1"></div>
        </div>
        {showHelp ? (
          <div className="md:p-2 h-full sm:hidden">
            1. If known, enter inmate's SCDC number or his/her State
            Identification (SID) into the appropriate box and click Submit.
            <br />
            2. If SCDC number and SID are unknown, enter the name of the inmate
            for whom you are searching. If you are unsure of an inmate's first
            name, leave it blank.
            <br />
            3. A phonetic search will return all inmate records that sound
            similar to the name you entered. If you leave "Phonetic Match"
            blank, the system will return only those records that begin with the
            letters of the name you entered.
            <br />
            4. Click on the row containing the inmate of interest and click to
            view detailed information. The inmate's search detail report will be
            displayed as a PDF file in a new browser window.
            <br />
            5. To view a glossary of terms and descriptions used in the Inmate
            Search Detail Report, click on the following link:{" "}
            <Link to={"/scdc-public/glossary"}>Glossary.</Link>
          </div>
        ) : null}
        <div className="md:p-2 h-full sm:block hidden">
          1. If known, enter inmate's SCDC number or his/her State
          Identification (SID) into the appropriate box and click Submit.
          <br />
          2. If SCDC number and SID are unknown, enter the name of the inmate
          for whom you are searching. If you are unsure of an inmate's first
          name, leave it blank.
          <br />
          3. A phonetic search will return all inmate records that sound similar
          to the name you entered. If you leave "Phonetic Match" blank, the
          system will return only those records that begin with the letters of
          the name you entered.
          <br />
          4. Click on the row containing the inmate of interest and click to
          view detailed information. The inmate's search detail report will be
          displayed as a PDF file in a new browser window.
          <br />
          5. To view a glossary of terms and descriptions used in the Inmate
          Search Detail Report, click on the following link:{" "}
          <Link to={"/scdc-public/glossary"}>Glossary.</Link>
        </div>
      </div>

      <div className="xl:flex block mt-1  ">
        <div className="  m-auto rounded-md sm:hidden">
          <div
            className="hover:bg-gray-200 rounded-md"
            onClick={() => setShowCOE(!showCOE)}
          >
            {!showCOE ? (
              <PlusCircleIcon className="h-5 float-left mt-1 mt-1" />
            ) : (
              <MinusCircleIcon className="h-5 float-left mt-1 mt-1" />
            )}
            <div className="ml-6 pt-px hover:bg-gray-200">COE</div>
            <div className="h-px bg-black mt-1"></div>
          </div>
          {showCOE ? <COE /> : null}
        </div>

        <Wrapper className="sm:block hidden p-0 m-0">
          <COE />
        </Wrapper>

        <InmateList />
      </div>
      <div className="w-full h-px bg-black"></div>
      <div className="text-center text-xs select-none">
        Copyright © 2002-2021 South Carolina Department of Corrections. All
        rights reserved.
      </div>
    </div>
  );
}

export default TabBasic;
